<template>
  <div v-if="getSelectedImage() != undefined">
    <div v-if="is_loading" class="loading operation_icon"></div>
    <img
      v-else
      @click="validateResource"
      @mouseover="onMouseOver"
      @mouseleave="onMouseLeave"
      style="min-width: 20px; max-width: 20px;"
      class="operation_icon"
      :src="getSelectedImage()"
    />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'completeness-indicator',
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    additional_data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      resource_data: this.payload,
      is_loading: false
    }
  },
  computed: {
    mergedData () {
      return { ...this.resource_data, ...this.additional_data }
    },
    ...mapGetters('modals', ['findModal'])
  },
  methods: {
    getSelectedImage () {
      if (this.mergedData.completeness == 'complete') {
        return '/green_v.png'
      }
      if (this.mergedData.completeness == 'incomplete') {
        return '/red_x.png'
      }
      if (this.mergedData.completeness == 'inactive') {
        return '/blue_x.png'
      }
      return undefined
    },
    getResourceId () {
      return this.payload.resource_id != undefined
        ? this.payload.resource_id
        : this.payload.id
    },
    validateResource () {
      this.removeFormModal()
      this.is_loading = true
      this.$network_utils
        .postEvent({
          current_resource_id: this.getResourceId(),
          resource_type: this.mergedData.resource_type,
          current_type: this.mergedData.resource_type,
          resource_type_id_string: this.getResourceId(),
          event: 'validate_resource'
        })
        .then(() => {
          setTimeout(() => {
            this.refreshData()
          }, 2000)
        })
    },
    refreshData () {
      this.$caller
        .request(
          'get',
          this.additional_data.api_path + '/' + this.getResourceId(),
          'admin_headers'
        )
        .then((response) => {
          this.resource_data = response
          this.is_loading = false
        })
    },
    onMouseOver () {
      this.create({
        designator: 'completeness-indicator-form-modal',
        component_name: 'CompletenessIndicatorForm',
        resource_type: this.mergedData.resource_type,
        resource_id: this.getResourceId(),
        modal_title: 'Completeness Indicator'
      })
    },
    onMouseLeave () {
      this.removeFormModal()
    },
    removeFormModal () {
      let completeness_indicator_modal = this.findModal({
        type: 'designator',
        value: 'completeness-indicator-form-modal'
      })
      this.remove(completeness_indicator_modal)
    },
    ...mapMutations('modals', ['remove', 'create'])
  }
}
</script>
